import { useEffect } from 'react';

const FlodeskForm = ({ formId = '698ff949955577ffd7fda382' }) => {
  useEffect(() => {
    // Inject Flodesk script into <head> if not already present
    const existingScript = document.querySelector('script[src*="flodesk"]');
    if (!existingScript) {
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');
    }

    // Initialize the form
    if (window.fd) {
      window.fd('form', {
        formId: formId,
        containerEl: `#fd-form-${formId}`
      });
    }
  }, [formId]);

  return (
    <div id={`fd-form-${formId}`}></div>
  );
};

export default FlodeskForm;
